import { createRouter, createWebHistory } from "vue-router";
import store from "../store/store";
import Home from "../pages/homepage";
import Privacy from '../pages/privacypage';
import Terms from '../pages/termspage';
import CookiePolicy from '../pages/cookie-policy.vue';
import About from '../pages/about';
import Contact from '../pages/contact';
import Faq from '../pages/faq';
import Blog from '../pages/blog';
import BlogSearch from '../pages/blogSearch';
import BlogByCategory from '../pages/blogByCategory';
import BlogDetail from '../pages/blogdetail';
import Pricing from '../pages/pricingpage';
import SurveyResponse from '../pages/survey-response.vue';
import Login from "../authpages/login.vue";
import Register from "../authpages/register.vue";
import VerifyEmail from "../authpages/verify-email.vue";
import SendEmailVericationLink from "../authpages/send-verification-link.vue";

import ChangePassword from "../authpages/change-password.vue";
import ResetPassword from "../authpages/reset-password.vue";
import AccountSetup from "../authpages/account-setup.vue";
import CertificateVerify from "../authpages/certificate-verify.vue";
// private section
import Private from "../private/private.vue";
import DashboardHome from "../private/dashboard/home.vue";

// administration
import SettingInfo from "../private/dashboard/admninistration/company-info.vue";
import EditCompanyInfo from "../private/dashboard/admninistration/edit-company-info.vue";

import AdminManageUser from "../private/dashboard/admninistration/manage-user.vue";
import AdminCreateUser from "../private/dashboard/admninistration/create-new-user.vue";
import AdminEditUser from "../private/dashboard/admninistration/edit-user.vue";

import AdminManageRole from "../private/dashboard/admninistration/manage-role.vue";
import AdminCreateRole from "../private/dashboard/admninistration/create-role.vue";
import AdminEditRole from "../private/dashboard/admninistration/edit-role.vue";

import AdminManageLocation from "../private/dashboard/admninistration/locations.vue";
import SetupWorkflow from "../private/dashboard/admninistration/workflow-setup.vue";
import Banks from "../private/dashboard/admninistration/bank-accounts.vue";
import AllBanks from "../private/dashboard/admninistration/all-banks.vue";
import PensionProvider from "../private/dashboard/admninistration/pension-providers.vue";
import FinancialPeriod from "../private/dashboard/admninistration/financial-period.vue";
import AllCurrencies from "../private/dashboard/admninistration/all-currencies.vue";
import PaymentGateway from "../private/dashboard/admninistration/payment-gateway.vue";



// creditor
import CreditorIndex from "../private/dashboard/creditor/creditor-index.vue";
import CreditorReceipt from "../private/dashboard/creditor/creditors-receipt.vue";
import PrintCreditor from "../private/dashboard/creditor/print-creditor-receipt.vue";
import getUserCredit from "../private/dashboard/creditor/user-creditor.vue";
// debitor
import DebitorIndex from "../private/dashboard/debitor/index.vue";
import DebitorReceipt from "../private/dashboard/debitor/debitor-receipt.vue";
import PrintDebitorReceipt from "../private/dashboard/debitor/print-debtor-receipt.vue";

import getUserDebit from "../private/dashboard/debitor/get-user-debit.vue";
// inventorymgt
import InventoryDashboard from "../private/dashboard/inventorymgt/inventory-dashboard.vue";
import AllProduct from "../private/dashboard/inventorymgt/allproducts.vue";
import AllProductLocation from "../private/dashboard/inventorymgt/allproductlocation.vue";
import AllStockAdjustment from "../private/dashboard/inventorymgt/allstockadjustment.vue";
import AllStockTransfer from "../private/dashboard/inventorymgt/allstocktransfer.vue";
import CreateProduct from "../private/dashboard/inventorymgt/createproduct.vue";
import CreateStockTransfer from "../private/dashboard/inventorymgt/createstocktransfer.vue";
import CreateStockAdjustment from "../private/dashboard/inventorymgt/createstockadjustment.vue";
import EditProduct from "../private/dashboard/inventorymgt/editproduct.vue";
import ViewProduct from "../private/dashboard/inventorymgt/view-product.vue";

import PrintStockAdjustment from "../private/dashboard/inventorymgt/print-stock-adjustment.vue";

import PrintStockTransfer from "../private/dashboard/inventorymgt/print-stock-transfer.vue";
import ViewStockAdjustment from "../private/dashboard/inventorymgt/view-stock-adjustment.vue";
import ViewStockTransfer from "../private/dashboard/inventorymgt/view-stock-transfer.vue";

import BulkProductUpload from "../private/dashboard/inventorymgt/bulk-product-upload.vue";
import ExpiredProducts from "../private/dashboard/inventorymgt/Expired-product.vue";
import AllInternalIssues from "../private/dashboard/inventorymgt/all-internal-issues.vue";
import CreateInternalIssue from "../private/dashboard/inventorymgt/create-internal-issue.vue";
import ViewInternalIssue from "../private/dashboard/inventorymgt/view-internal-issue.vue";

// setting

import AllCustomers from "../private/dashboard/setting/allcustomers.vue";
import AllPayments from "../private/dashboard/setting/allpayments.vue";
import AllSuppliers from "../private/dashboard/setting/allsuppliers.vue";
import InventoryCategory from "../private/dashboard/setting/inventorycategory.vue";
import InventorySubcategory from "../private/dashboard/setting/inventorysubcategory.vue";
import Companies from "../private/dashboard/admninistration/allcompanies.vue";
import CreateCompany from "../private/dashboard/admninistration/create-company.vue";
import EditCompany from "../private/dashboard/admninistration/edit-company.vue";

import Notification from "../private/dashboard/setting/Notification.vue";
import Taxes from "../private/dashboard/setting/taxes.vue";
import BulkCustomerUpload from "../private/dashboard/setting/bulk-customers-upload.vue";
import BulkSuppliersUpload from "../private/dashboard/setting/bulk-suppliers-upload.vue";
import CreateCustomer from "../private/dashboard/setting/create-customer.vue";
import EditCustomer from "../private/dashboard/setting/edit-customer.vue";

import EditSupplier from "../private/dashboard/setting/edit-supplier.vue";
import CreateSupplier from "../private/dashboard/setting/create-supplier.vue";

import AdministrationManageStore from "../private/dashboard/setting/allstore.vue";
import AdminCreateStore from "../private/dashboard/setting/create-store.vue";
import AdminEditStore from "../private/dashboard/setting/edit-store.vue";


// purchase
import AllPurchase from "../private/dashboard/purchase/all-purchases.vue";
import MakePurchase from "../private/dashboard/purchase/make-purchase.vue";
import PrintPurchase from "../private/dashboard/purchase/print-purchase-receipt.vue";
import PurchaseReceipt from "../private/dashboard/purchase/purchase-receipt.vue";
import ViewPurchase from "../private/dashboard/purchase/view-purchase.vue";

// report
import AllReports from "../private/dashboard/reports/all-reports.vue";
import Performance from "../private/dashboard/reports/performance.vue";
import ReportBin from "../private/dashboard/reports/reportbin.vue";
import CustomerReport from "../private/dashboard/reports/customer-report";
import UserCustomerReport from "../private/dashboard/reports/user-customer-report";
import SalesReport from "../private/dashboard/reports/sales-report";
import ProfitabilityReport from "../private/dashboard/reports/profitability-report";
import PurchaseReport from "../private/dashboard/reports/purchase-report";
import StockTransferReport from "../private/dashboard/reports/stock-transfer-report";
import StockAdjustmentReport from "../private/dashboard/reports/stock-adjustment-report";
import SalesByCategory from "../private/dashboard/reports/salesbycategory";
import AuditTrail from "../private/dashboard/reports/audit-trail";
import InventoryStatusReport from "../private/dashboard/reports/inventory-status-report.vue";

// sales
import AllSales from "../private/dashboard/sales/allsales.vue";
import MakeSales from "../private/dashboard/sales/make-sales.vue";

import PrintSalesReceipt from "../private/dashboard/sales/print-sales-receipt.vue";
// import Print58mmSalesReceipt from "../private/dashboard/sales/print58mm-sales-receipt.vue";


import SalesReceiptCash from "../private/dashboard/sales/sales-receipt-cash.vue";
// import SalesReceiptCredit from "../private/dashboard/sales/sales-receipt-credit.vue";
import ViewSale from "../private/dashboard/sales/view-sales.vue";

// subscription
import SubscriptionIndex from '../private/dashboard/subscription/subscription.vue';
import subscriptionPlan from '../private/dashboard/subscription/subscriptionplan.vue';
import subscriptionPayment from '../private/dashboard/subscription/payment.vue';
import subscriptionPlanInvoice from '../private/dashboard/subscription/invoice.vue';

// invoice
import InvoiceHistory from "../private/dashboard/invoice/view-invoices.vue";
import InvoiceDetail from "../private/dashboard/invoice/invoice-details.vue";
import CreateInvoice from "../private/dashboard/invoice/create-invoice.vue";
import EditInvoice from "../private/dashboard/invoice/edit-invoice.vue";
import RecreateInvoice from "../private/dashboard/invoice/recreate-invoice.vue";
import RecordInvoicePayment from "../private/dashboard/invoice/record-payment.vue";
import OnlineInvoicePayment from "../private/dashboard/invoice/online-payment.vue";
import InvoicePaymentHistory from "../private/dashboard/invoice/payment-history.vue";

// billing
import ManageBilling from "../private/dashboard/billing/view-billings.vue";
import BillingDetail from "../private/dashboard/billing/billing-details.vue";
import CreateBilling from "../private/dashboard/billing/create-billing.vue";
import BillingCustomers from "../private/dashboard/billing/billing-customers.vue";
import UploadBillingCustomers from "../private/dashboard/billing/bulk-customers-upload.vue";
import BillingGroups from "../private/dashboard/billing/billing-groups.vue";

// expense
import ManageExpenses from "../private/dashboard/expense/view-expenses.vue";
import ExpenseDetail from "../private/dashboard/expense/expense-details.vue";
import CreateExpense from "../private/dashboard/expense/create-expense.vue";
import ExpenseCategory from "../private/dashboard/expense/categories.vue";

// accounting
import ManageJournals from "../private/dashboard/accounting/journals.vue";
import CreateJournal from "../private/dashboard/accounting/create-journal.vue";
import ManageJournalEntries from "../private/dashboard/accounting/journal-entries.vue";
import ManageLedger from "../private/dashboard/accounting/ledgers.vue";
import Transactions from "../private/dashboard/accounting/transactions.vue";
import TransactionDetail from "../private/dashboard/accounting/transaction-details.vue";
import TransactionUpload from "../private/dashboard/accounting/bulk-transaction-upload.vue";
import AccountingDashboard from "../private/dashboard/accounting/dashboard.vue";
import VendorPayments from "../private/dashboard/accounting/vendor-payments.vue";
import PaymentVouchers from "../private/dashboard/accounting/payment-vouchers.vue";
import Bills from "../private/dashboard/accounting/bills.vue";
import PettyCash from "../private/dashboard/accounting/petty-cash.vue";
import FiscalYears from "../private/dashboard/accounting/fiscal-years.vue";
import BankAccountsAccounting from "../private/dashboard/accounting/bank-accounts.vue";

import BalanceSheetReport from "../private/dashboard/accounting/reports/balance-sheet.vue";
import TrialBalanceReport from "../private/dashboard/accounting/reports/trial-balance.vue";
import IncomeStatementReport from "../private/dashboard/accounting/reports/income-statement.vue";
import ChartOfAccount from "../private/dashboard/accounting/reports/chart-of-account.vue";
import CashFlowStatement from "../private/dashboard/accounting/reports/cash-flow.vue";

// payroll
import PayrollAdditionalDeduction from "../private/dashboard/hr/payroll/additional-deductions.vue";
import PayrollAdditionalEarning from "../private/dashboard/hr/payroll/additional-earnings.vue";
import PayrollPeriod from "../private/dashboard/hr/payroll/periods.vue";
import PayrollDashboard from "../private/dashboard/hr/payroll/dashboard.vue";
import PayrollHistory from "../private/dashboard/hr/payroll/payroll-history.vue";
import Payslip from "../private/dashboard/hr/payroll/payslip.vue";
import PayrollDetails from "../private/dashboard/hr/payroll/payroll-details.vue";
import CreatePayroll from "../private/dashboard/hr/payroll/create-payroll.vue";
import PaymentSuccess from "../components/PaymentSuccess.vue";

import ManagePaygrade from "../private/dashboard/hr/settings/paygrade.vue";
import PaygradeDetail from "../private/dashboard/hr/settings/paygrade-details.vue";
import SalaryComponents from "../private/dashboard/hr/settings/salary-components.vue";
import StatutoryDeductions from "../private/dashboard/hr/settings/statutory-deductions.vue";
import ManageDepartment from "../private/dashboard/hr/settings/department.vue";
import ManageUnit from "../private/dashboard/hr/settings/unit.vue";
import ManagePosition from "../private/dashboard/hr/settings/position.vue";

import ManageEmployeesDashboard from "../private/dashboard/hr/employees/dashboard.vue";
import ManageEmployees from "../private/dashboard/hr/employees/employees.vue";
import CreateEmployee from "../private/dashboard/hr/employees/create-employee.vue";
import EmployeeDetail from "../private/dashboard/hr/employees/employee-detail.vue";
import ManageEmployeeInvites from "../private/dashboard/hr/employees/employee-invites.vue";
import AcceptEmployeeInvite from "../private/dashboard/hr/employees/accept-invite.vue";


import ManageApprovals from "../private/dashboard/approvals.vue";

// HR — Attendance & Leave
import HrAttendance from "../private/dashboard/hr/attendance/attendance.vue";
import HrShifts from "../private/dashboard/hr/attendance/shifts.vue";
import HrRota from "../private/dashboard/hr/attendance/rota.vue";
import MyAttendance from "../private/dashboard/hr/attendance/my-attendance.vue";
import MyDashboard from "../private/dashboard/hr/self-service/my-dashboard.vue";
import MyShifts from "../private/dashboard/hr/self-service/my-shifts.vue";
import MyPayslips from "../private/dashboard/hr/self-service/my-payslips.vue";
import MyProfile from "../private/dashboard/hr/self-service/my-profile.vue";
import MyLoans  from "../private/dashboard/hr/self-service/my-loans.vue";
import MyAssets from "../private/dashboard/hr/self-service/my-assets.vue";
import MyLeaves from "../private/dashboard/hr/self-service/my-leaves.vue";
import MyNotifications   from "../private/dashboard/hr/self-service/my-notifications.vue";
import MyAnnouncements  from "../private/dashboard/hr/self-service/my-announcements.vue";
import MyInterviews     from "../private/dashboard/hr/self-service/my-interviews.vue";
import HrLoans     from "../private/dashboard/hr/loans/loans.vue";
import HrAssets    from "../private/dashboard/hr/assets/assets.vue";
import HrDocuments from "../private/dashboard/hr/documents/documents.vue";
import MyDocuments from "../private/dashboard/hr/self-service/my-documents.vue";
import JobListings from "../pages/job-listings.vue";
import JobDetail from "../pages/job-detail.vue";
import PublicVisitorCheckIn  from "../pages/visitor-checkin.vue";
import VisitorPreArrival     from "../pages/visitor-pre-arrival.vue";
import VisitorMobileCheckIn  from "../pages/visitor-mobile-checkin.vue";
import HrRecruitment from "../private/dashboard/hr/recruitment/recruitment.vue";
import WorkforcePlanForm from "../private/dashboard/hr/recruitment/workforce-plan-form.vue";
import JobRequisitionForm from "../private/dashboard/hr/recruitment/job-requisition-form.vue";
import HrLeave from "../private/dashboard/hr/leave/leave.vue";
import HrLeaveBalances from "../private/dashboard/hr/leave/leave-balances.vue";
import HrPublicHolidays from "../private/dashboard/hr/settings/public-holidays.vue";
import HrClients from "../private/dashboard/hr/settings/clients.vue";
import HrAnnouncements from "../private/dashboard/hr/announcements/announcements.vue";
import HrChat from "../private/dashboard/hr/chat/chat.vue";
// PMS — Performance Management System
import PmsCycles from "../private/dashboard/hr/performance/cycles.vue";
import PmsCycleDetail from "../private/dashboard/hr/performance/cycle-detail.vue";
import PmsGoals from "../private/dashboard/hr/performance/goals.vue";
import PmsKpiLibrary from "../private/dashboard/hr/performance/kpi-library.vue";
import PmsCompetencies from "../private/dashboard/hr/performance/competencies.vue";
import PmsReviews from "../private/dashboard/hr/performance/reviews.vue";
import PmsReviewForm from "../private/dashboard/hr/performance/review-form.vue";
import PmsBonusEngine from "../private/dashboard/hr/performance/bonus-engine.vue";
import PmsPayrollSync from "../private/dashboard/hr/performance/payroll-sync.vue";
import PmsReports from "../private/dashboard/hr/performance/reports.vue";
// training
import TrainingDashboard from "../private/dashboard/hr/training/training-dashboard.vue";
import TrainingCourses from "../private/dashboard/hr/training/courses.vue";
import CourseForm from "../private/dashboard/hr/training/course-form.vue";
import MyTraining from "../private/dashboard/hr/training/my-training.vue";
import TrainingAssignments from "../private/dashboard/hr/training/assignments.vue";
import TrainingEnrolments from "../private/dashboard/hr/training/enrolments.vue";
import TrainingPlayer from "../private/dashboard/hr/training/training-player.vue";
import TrainingCertificates from "../private/dashboard/hr/training/certificates.vue";
import VisitorDashboard from "../private/dashboard/hr/visitors/dashboard.vue";
import VisitorPreRegister from "../private/dashboard/hr/visitors/pre-register.vue";
import VisitorUpcoming from "../private/dashboard/hr/visitors/upcoming.vue";
import VisitorCheckIn from "../private/dashboard/hr/visitors/check-in.vue";
import VisitorActive from "../private/dashboard/hr/visitors/active.vue";
import VisitorHistory from "../private/dashboard/hr/visitors/history.vue";
import VisitorSettings from "../private/dashboard/hr/visitors/settings.vue";
import VisitorDirectory    from "../private/dashboard/hr/visitors/visitors-directory.vue";
import VisitorTypes       from "../private/dashboard/hr/visitors/visitor-types.vue";
import VisitorSites       from "../private/dashboard/hr/visitors/sites.vue";
import VisitorLockers     from "../private/dashboard/hr/visitors/lockers.vue";
import VisitorWatchlist   from "../private/dashboard/hr/visitors/watchlist.vue";
import VisitorDocuments   from "../private/dashboard/hr/visitors/documents.vue";
import VisitorApprovals   from "../private/dashboard/hr/visitors/approvals.vue";
import VisitorRollCall    from "../private/dashboard/hr/visitors/roll-call.vue";
import VisitorEvacuation  from "../private/dashboard/hr/visitors/evacuation.vue";
import VisitorReports     from "../private/dashboard/hr/visitors/reports.vue";
import VisitorAuditTrail  from "../private/dashboard/hr/visitors/audit-trail.vue";
import VisitorDSR         from "../private/dashboard/hr/visitors/dsr.vue";
import VisitorGroupVisits from "../private/dashboard/hr/visitors/group-visits.vue";
import DeveloperApiKeys from "../private/dashboard/developer/api-keys.vue";
import DeveloperWebhooks from "../private/dashboard/developer/webhooks.vue";
import DeveloperDocs    from "../private/dashboard/developer/docs.vue";
import BusinessWallet from "../private/dashboard/wallet/wallet.vue";
import ExitPipeline  from "../private/dashboard/hr/exits/pipeline.vue";
import ExitCases     from "../private/dashboard/hr/exits/index.vue";
import ExitCreate    from "../private/dashboard/hr/exits/create.vue";
import ExitShow      from "../private/dashboard/hr/exits/show.vue";
import ExitSettings  from "../private/dashboard/hr/exits/settings.vue";
import MyExit        from "../private/dashboard/ess/my-exit.vue";
import SupportTickets from "../private/dashboard/support/tickets.vue";
import CrmDashboard from "../private/dashboard/crm/crm-dashboard.vue";
import CrmLeads from "../private/dashboard/crm/crm-leads.vue";
import CrmContacts from "../private/dashboard/crm/crm-contacts.vue";
import CrmAccounts from "../private/dashboard/crm/crm-accounts.vue";
import CrmOpportunities from "../private/dashboard/crm/crm-opportunities.vue";
import CrmActivities from "../private/dashboard/crm/crm-activities.vue";
import CrmSegments from "../private/dashboard/crm/crm-segments.vue";
import CrmCampaigns from "../private/dashboard/crm/crm-campaigns.vue";
import CrmJourneys from "../private/dashboard/crm/crm-journeys.vue";
import CrmCases from "../private/dashboard/crm/crm-cases.vue";
import CrmLoyalty from "../private/dashboard/crm/crm-loyalty.vue";
import CrmSurveys from "../private/dashboard/crm/crm-surveys.vue";
import ProcurementDashboard from "../private/dashboard/procurement/procurement-dashboard.vue";
import ProcurementVendors from "../private/dashboard/procurement/vendors.vue";
import ProcurementVendorProfile from "../private/dashboard/procurement/vendor-profile.vue";
import VendorLogin from "../vendor/vendor-login.vue";
import VendorDashboard from "../vendor/vendor-dashboard.vue";
import VendorInvoice from "../vendor/vendor-invoice.vue";
import VendorCategories from "../private/dashboard/procurement/vendor-categories.vue";
import PurchaseRequisitions from "../private/dashboard/procurement/purchase-requisitions.vue";
import PrForm from "../private/dashboard/procurement/pr-form.vue";
import PrDetail from "../private/dashboard/procurement/pr-detail.vue";
import PrintPR from "../private/dashboard/procurement/print-pr.vue";
import PurchaseOrders from "../private/dashboard/procurement/purchase-orders.vue";
import PoForm from "../private/dashboard/procurement/po-form.vue";
import PoDetail from "../private/dashboard/procurement/po-detail.vue";
import PrintPO from "../private/dashboard/procurement/print-po.vue";
import PrintGRN from "../private/dashboard/procurement/print-grn.vue";

import SourcingEvents from "../private/dashboard/procurement/sourcing-events.vue";
import SourcingEventForm from "../private/dashboard/procurement/sourcing-event-form.vue";
import SourcingEventDetail from "../private/dashboard/procurement/sourcing-event-detail.vue";
import SourcingEventAnalysis from "../private/dashboard/procurement/sourcing-event-analysis.vue";
import PrjProjects from "../private/dashboard/projects/index.vue";
import PrjProjectDashboard from "../private/dashboard/projects/project-dashboard.vue";
import PrjProjectDetail from "../private/dashboard/projects/project-detail.vue";
import PrjTimesheet from "../private/dashboard/projects/timesheet.vue";
import PrjBudgetDetail from "../private/dashboard/projects/budget-detail.vue";


export const isLoggedIn = () => {
  return localStorage.getItem("token");
};

const meta = {
  requiresSubscription: true,
  isAuthenticated: true
}
const meta2 = {
  requiresSubscription: false,
  isAuthenticated: true
}

const routes = [
  { path: "/home", component: Home },
  { path: "/privacy-policy", component: Privacy },
  { path: "/terms-and-conditions", component: Terms },
  { path: "/cookie-policy", component: CookiePolicy },
  { path: "/pricing", component: Pricing },
  { path: "/contact", component: Contact },
  { path: "/about", component: About },
  { path: "/faq", component: Faq },
  { path: "/blog", component: Blog },
  { path: "/search/blog", component: BlogSearch },
  { path: "/blog/category/:id", component: BlogByCategory },
  { path: "/blog/:id", component: BlogDetail },
  { path: "/:companyCode/survey/:token", component: SurveyResponse, name: "SurveyResponse" },
  { path: "/careers/:companyCode", component: JobListings, name: "JobListings" },
  { path: "/careers/:companyCode/:slug", component: JobDetail, name: "JobDetail" },
  { path: "/visitor-checkin/:companyCode/:businessId",              component: PublicVisitorCheckIn, name: "PublicVisitorCheckIn" },
  { path: "/visitor-pre-arrival/:companyCode/:businessId/:token",   component: VisitorPreArrival,    name: "VisitorPreArrival" },
  { path: "/visitor-mobile-checkin/:companyCode/:businessId/:token", component: VisitorMobileCheckIn, name: "VisitorMobileCheckIn" },
  { path: "/auth/login", component: Login },
  { path: "/auth/register", component: Register },
  { path: "/auth/change-password/:token", component: ChangePassword },
  { path: "/auth/reset-password", component: ResetPassword },
  { path: "/auth/verify/account/:token", component: VerifyEmail },
  { path: "/auth/send-email-verifcation", component: SendEmailVericationLink },
  { path: "/:companyCode/certificates/verify/:token", component: CertificateVerify, name: "CertificateVerify" },
  {
    path: "/auth/account-setup",
    component: AccountSetup,
    beforeEnter(to, from, next) {
      if (!localStorage.getItem('setup_token')) {
        next('/auth/login');
      } else {
        next();
      }
    },
  },
  { path: "/payment-success", component: PaymentSuccess },
  {
    path: "/invoice/payment/:company/:invoice",
    component: OnlineInvoicePayment,
    name: "Online Invoice Payment"
  },

  { path: "/invite/employee/:database/:token", component: AcceptEmployeeInvite, name: '' },

  // ── Vendor portal (standalone, no main-app auth) ──────────────────────
  { path: "/vendor/:companyCode",           redirect: to => `/vendor/${to.params.companyCode}/login` },
  { path: "/vendor/:companyCode/login",     component: VendorLogin,     name: "VendorLogin" },
  { path: "/vendor/:companyCode/dashboard", component: VendorDashboard, name: "VendorDashboard" },
  { path: "/vendor/:companyCode/invoice/:invoiceId", component: VendorInvoice, name: "VendorInvoice" },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: Home,
    meta: {
      title: 'Error',
    },
  },

  // ── Authenticated / company-scoped ──────────────────────────────────────
  // Every company has its own URL namespace: /{companyCode}/dashboard, etc.
  // The companyCode is a 6-char short code assigned at registration (e.g. ACM001).
  {
    path: "/:companyCode",
    component: Private,
    beforeEnter(to, from, next) {
      if (!isLoggedIn()) { next("/home"); return; }

      const code = to.params.companyCode;
      // Company codes from the generator are 4-8 alphanumeric chars with at
      // least one digit (e.g. ACM001, ESS002).  If the captured segment looks
      // like a route name (no digit, or has hyphens), the navigation arrived
      // here without the company-code prefix — recover by redirecting.
      const isValidCode = /^[A-Za-z0-9]{4,8}$/.test(code) && /[0-9]/.test(code);

      if (!isValidCode) {
        const realCode = localStorage.getItem('companyCode');
        if (realCode && realCode !== 'null' && realCode !== 'undefined') {
          next({ path: `/${realCode}${to.fullPath}`, replace: true });
        } else {
          next('/home');
        }
        return;
      }

      localStorage.setItem('companyCode', to.params.companyCode);
      next();
    },

    children: [
      {
        path: "", component: DashboardHome, name: "Dashboard",
        beforeEnter(to, from, next) {
          const p = store.state.getCurrentUserPermission;
          if (p !== null && !p?.view_dashboard) {
            const code = to.params.companyCode || localStorage.getItem('companyCode') || '';
            next(code ? `/${code}/hr/my-dashboard` : '/hr/my-dashboard');
            return;
          }
          next();
        },
      },

      { path: "manage-store", component: AdministrationManageStore, name: "Manage Store", meta },
      { path: "create-store", component: AdminCreateStore, name: "Create Store", meta },
      { path: "manage-user", component: AdminManageUser, name: "Manage User", meta },
      { path: "create-user", component: AdminCreateUser, name: "Create User", meta },
      { path: "edit-user/:id", component: AdminEditUser, name: "Edit User", meta },

      { path: "manage-role", component: AdminManageRole, name: "Manage Role", meta },
      { path: "create-role", component: AdminCreateRole, name: "Create Role", meta },
      { path: "edit-role/:id", component: AdminEditRole, name: "Edit Role", meta },

      { path: "edit-store/:id", component: AdminEditStore, name: "Edit Store", meta },

      { path: "manage-business-locations", component: AdminManageLocation, name: "Manage Business Locations", meta },

      { path: "creditor", component: CreditorIndex, name: "Creditor", meta },
      { path: "creditor-receipt/:id", component: CreditorReceipt, name: "View Creditor Receipt", meta },
      { path: "print58mm-creditor-receipt/:id", component: PrintCreditor, name: "Print 58mm Creditor Receipt", meta },
      { path: "print80mm-creditor-receipt/:id", component: PrintCreditor, name: "Print 80mm Creditor Receipt", meta },
      { path: "user-credit/:supplierId", component: getUserCredit, name: "User Credit", meta },

      { path: "debtor", component: DebitorIndex, name: "Debtor", meta },
      { path: "debtor-receipt/:id", component: DebitorReceipt, name: "View Debtor Receipt", meta },
      { path: "print80mm-debtor-receipt/:id", component: PrintDebitorReceipt, name: "Print 80mm Debtor Receipt", meta },
      { path: "print58mm-debtor-receipt/:id", component: PrintDebitorReceipt, name: "Print 58mm Debtor Receipt", meta },
      { path: "user-debtor/:id", component: getUserDebit, name: "User Debtor", meta },

      { path: "all-currencies", component: AllCurrencies, name: "All Currency", meta },
      { path: "business-bank-accounts", component: Banks, name: "Manage Business Bank Accounts", meta },
      { path: "all-banks", component: AllBanks, name: "Manage All Banks", meta },
      { path: "pension-providers", component: PensionProvider, name: "Manage Pension Providers", meta },
      { path: "payment-gateway", component: PaymentGateway, name: "Payment Gateway", meta },
      { path: "edit-company-info", component: EditCompanyInfo, name: "Edit Company Info", meta },

      { path: "inventory/dashboard", component: InventoryDashboard, name: "Inventory Dashboard", meta2 },
      { path: "all-products", component: AllProduct, name: "All Products", meta2 },
      { path: "all-product-location", component: AllProductLocation, name: "Product Location", meta },
      { path: "all-stock-transfer", component: AllStockTransfer, name: "Stock Transfer", meta },
      { path: "all-stock-adjustment", component: AllStockAdjustment, name: "Stock Adjustment", meta },
      { path: "create-product", component: CreateProduct, name: "Create Product", meta2 },
      { path: "create-stock-transfer", component: CreateStockTransfer, name: "Create Stock Transfer", meta },
      { path: "create-stock-adjustment", component: CreateStockAdjustment, name: "Create Stock Adjustment", meta },
      { path: "edit-product/:id", component: EditProduct, name: "Edit Product", meta },
      { path: "view-product/:id", component: ViewProduct, name: "View Product", meta },
      { path: "print-stock-adjustment/:id",     component: PrintStockAdjustment, name: "Print Stock Adjustment",      meta },
      { path: "print80mm-stock-adjustment/:id", component: PrintStockAdjustment, name: "Print 80mm Stock Adjustment", meta },
      { path: "print58mm-stock-adjustment/:id", component: PrintStockAdjustment, name: "Print 58mm Stock Adjustment", meta },
      { path: "print-stock-transfer/:id",     component: PrintStockTransfer, name: "Print Stock Transfer",      meta },
      { path: "view-stock-transfer/:id",       component: ViewStockTransfer,  name: "View Stock Transfer",       meta },
      { path: "print80mm-stock-transfer/:id",  component: PrintStockTransfer, name: "Print 80mm Stock Transfer", meta },
      { path: "print58mm-stock-transfer/:id",  component: PrintStockTransfer, name: "Print 58mm Stock Transfer", meta },
      { path: "view-stock-adjustment/:id", component: ViewStockAdjustment, name: "View Stock Adjustment", meta },
      { path: "bulk-product-upload", component: BulkProductUpload, name: "Bulk Product Upload", meta },
      { path: "expired-products", component: ExpiredProducts, name: "Expired Products", meta },
      { path: "all-internal-issues",        component: AllInternalIssues,  name: "All Internal Issues",        meta },
      { path: "create-internal-issue",      component: CreateInternalIssue, name: "Create Internal Issue",     meta },
      { path: "view-internal-issue/:id",    component: ViewInternalIssue,   name: "View Internal Issue",       meta },

      { path: "businesses", component: Companies, name: "All Business" },
      { path: "create-business", component: CreateCompany, name: "Create Business" },
      { path: "edit-business/:id", component: EditCompany, name: "Edit Business" },
      { path: "company-info", component: SettingInfo, name: "Company Info" },

      { path: "all-customers", component: AllCustomers, name: "All Customers" },
      { path: "all-payments", component: AllPayments, name: "All Payments", meta2 },
      { path: "all-suppliers", component: AllSuppliers, name: "All Suppliers" },
      { path: "inventory-category", component: InventoryCategory, name: "Inventory Category" },
      { path: "inventory-subcategory", component: InventorySubcategory, name: "Inventory Subcategory" },
      { path: "notifications", component: Notification, name: "Notification" },
      { path: "tax", component: Taxes, name: "Tax" },
      { path: "financial-period", component: FinancialPeriod, name: "Financial Period" },
      { path: "bulk-customers-upload", component: BulkCustomerUpload, name: "Bulk Customer Upload" },
      { path: "bulk-suppliers-upload", component: BulkSuppliersUpload, name: "Bulk Supplier Upload" },
      { path: "create-customer", component: CreateCustomer, name: "Create Customer" },
      { path: "edit-customer/:id", component: EditCustomer, name: "Edit Customer" },
      { path: "edit-supplier/:id", component: EditSupplier, name: "Edit Supplier" },
      { path: "create-supplier", component: CreateSupplier, name: "Create Supplier" },

      { path: "all-purchases", component: AllPurchase, name: "All Purchase", meta2 },
      { path: "make-purchase", component: MakePurchase, name: "Make Purchase", meta },
      { path: "purchase-receipt/:id", component: PurchaseReceipt, name: "View Purchase Receipt", meta },
      { path: "print58mm-purchase-receipt/:id", component: PrintPurchase, name: "Print 58mm Purchase Receipt", meta },
      { path: "print80mm-purchase-receipt/:id", component: PrintPurchase, name: "Print 80mm Purchase Receipt", meta },
      { path: "view-purchase/:id", component: ViewPurchase, name: "Purchase View", meta },

      { path: "all-reports", component: AllReports, name: "All Reports" },
      { path: "performance", component: Performance, name: "Performance" },
      { path: "report-bin", component: ReportBin, name: "Report Bin" },
      { path: "customer-report", component: CustomerReport, name: "Customer Report" },
      { path: "user-customer-report/:customerId", component: UserCustomerReport, name: "User Customer Report" },
      { path: "sales-report", component: SalesReport, name: "Sales Report" },
      { path: "profitability-report", component: ProfitabilityReport, name: "Profitability Report" },
      { path: "purchase-report", component: PurchaseReport, name: "Purchase Report" },
      { path: "stock-transfer-report", component: StockTransferReport, name: "Stock Transfer Report" },
      { path: "stock-adjustment-report", component: StockAdjustmentReport, name: "Stock Adjustment Report" },
      { path: "sales-by-category", component: SalesByCategory, name: "Sales By Category" },
      { path: "audit-trail", component: AuditTrail, name: "Audit Trail" },
      { path: "inventory-status-report", component: InventoryStatusReport, name: "Inventory Status Report" },

      { path: "all-sales", component: AllSales, name: "All Sales", meta2 },
      { path: "make-sales", component: MakeSales, name: "Make Sales", meta },
      { path: "sales-receipt/:id", component: SalesReceiptCash, name: "View Sales Receipt", meta },
      { path: "view-sales/:id", component: ViewSale, name: "View Sales", meta },
      { path: "print58mm-sales-receipt/:id", component: PrintSalesReceipt, name: "Print 58mm Sales Receipt", meta },
      { path: "print80mm-sales-receipt/:id", component: PrintSalesReceipt, name: "Print 80mm Sales Receipt", meta },
      { path: "sales-receipt-credit/:id", component: SalesReceiptCash, name: "Sales Receipt Credit", meta },

      {
        path: "subscribe/:id?", component: SubscriptionIndex, name: "Subscribe",
        beforeEnter(to, from, next) {
          const u = store.state.getLoggedInUser;
          const p = store.state.getCurrentUserPermission;
          if (u?.is_super === 1 || p?.manage_subscription) { next(); return; }
          if (p !== null) {
            const code = to.params.companyCode || localStorage.getItem('companyCode') || '';
            next(code ? `/${code}/hr/my-dashboard` : '/hr/my-dashboard');
          } else { next(); }
        },
      },
      {
        path: "subscription-plan", component: subscriptionPlan, name: "Subscription Plan",
        beforeEnter(to, from, next) {
          const u = store.state.getLoggedInUser;
          const p = store.state.getCurrentUserPermission;
          if (u?.is_super === 1 || p?.manage_subscription) { next(); return; }
          if (p !== null) {
            const code = to.params.companyCode || localStorage.getItem('companyCode') || '';
            next(code ? `/${code}/hr/my-dashboard` : '/hr/my-dashboard');
          } else { next(); }
        },
      },
      { path: "subscription/payment-invoice/:id", component: subscriptionPlanInvoice, name: "Subscription Payment Invoice" },
      { path: "subscription-payment/:id", component: subscriptionPayment, name: "Subscription Payment" },

      { path: "invoice-history", component: InvoiceHistory, name: "Invoices", meta2 },
      { path: "invoice-payment-history", component: InvoicePaymentHistory, name: "Invoice Payment History", meta2 },
      { path: "create-invoice", component: CreateInvoice, name: "Create Invoice", meta },
      { path: "invoice/update/:id", component: EditInvoice, name: "Edit Invoice", meta },
      { path: "invoice/:id/re-create", component: RecreateInvoice, name: "Re-Create Invoice", meta },
      { path: "invoice/detail/:id", component: InvoiceDetail, name: "Invoice Detail", meta },
      { path: "invoice/record-payment/:id", component: RecordInvoicePayment, name: "Record Invoice Payment", meta },

      { path: "manage-billing", component: ManageBilling, name: "Manage Billing", meta2 },
      { path: "billing/detail/:id", component: BillingDetail, name: "Billing Detail", meta },
      { path: "create-billing", component: CreateBilling, name: "Create Billing", meta },
      { path: "manage-billing-groups", component: BillingGroups, name: "Billing Groups", meta },
      { path: "manage-billing-customers", component: BillingCustomers, name: "Billing Customers", meta },
      { path: "upload-billing-customers", component: UploadBillingCustomers, name: "Upload Billing Customers", meta },

      { path: "manage-expenses", component: ManageExpenses, name: "Manage Expenses", meta2 },
      { path: "expense/detail/:id", component: ExpenseDetail, name: "Expense Detail", meta },
      { path: "create-expense", component: CreateExpense, name: "Create Expense", meta },
      { path: "manage-expense-category", component: ExpenseCategory, name: "Expense Category", meta },

      { path: "accounting/dashboard", component: AccountingDashboard, name: "Accounting Dashboard", meta2 },
      { path: "accounting/vendor-payments", component: VendorPayments, name: "Vendor Payments", meta2 },
      { path: "accounting/payment-vouchers", component: PaymentVouchers, name: "Payment Vouchers", meta2 },
      { path: "accounting/bills", component: Bills, name: "Bills", meta2 },
      { path: "accounting/petty-cash", component: PettyCash, name: "Petty Cash", meta2 },
      { path: "accounting/fiscal-years", component: FiscalYears, name: "Fiscal Years", meta2 },
      { path: "accounting/bank-accounts-setup", component: BankAccountsAccounting, name: "Bank Accounts Setup", meta2 },
      { path: "manage-journals", component: ManageJournals, name: "Manage Journals", meta2 },
      { path: "post-transaction", component: CreateJournal, name: "New Journal", meta2 },
      { path: "journal-entries", component: ManageJournalEntries, name: "Journal Entries", meta2 },
      { path: "manage-ledgers", component: ManageLedger, name: "Manage Ledgers", meta },
      { path: "transactions", component: Transactions, name: "Transactions", meta },
      { path: "transactions/:id", component: TransactionDetail, name: "Transaction Detail", meta },
      { path: "upload-transaction", component: TransactionUpload, name: "Upload Transaction", meta },

      { path: "balance-sheet-report", component: BalanceSheetReport, name: "Balance Sheet Report", meta2 },
      { path: "trial-balance-report", component: TrialBalanceReport, name: "Trial Balance Report", meta2 },
      { path: "income-statement-report", component: IncomeStatementReport, name: "Income Statement Report", meta2 },
      { path: "chart-of-account", component: ChartOfAccount, name: "Chart of Account", meta2 },
      { path: "cash-flow-statement", component: CashFlowStatement, name: "Cash Flow Statement", meta2 },

      { path: "payroll-additional-earnings", component: PayrollAdditionalEarning, name: "Payroll Additional Earning", meta2 },
      { path: "payroll-additional-deductions", component: PayrollAdditionalDeduction, name: "Payroll Additional Deduction", meta2 },
      { path: "payroll/dashboard", component: PayrollDashboard, name: "Payroll Dashboard", meta2 },
      { path: "payroll-periods", component: PayrollPeriod, name: "Payroll Periods", meta2 },
      { path: "create-payroll", component: CreatePayroll, name: "Create Payroll", meta2 },
      { path: "payroll-history", component: PayrollHistory, name: "Payroll History", meta2 },
      { path: "payroll/:id", component: PayrollDetails, name: "Payroll Details", meta2 },
      { path: "payslip/:id", component: Payslip, name: "Payslip", meta2 },
      { path: "payroll/statutory-deductions", component: StatutoryDeductions, name: "Payroll Statutory Deductions", meta2 },

      { path: "manage-paygrade", component: ManagePaygrade, name: "Manage Paygrade", meta2 },
      { path: "paygrade/:id", component: PaygradeDetail, name: "Paygrade Detail", meta2 },
      { path: "salary-components", component: SalaryComponents, name: "Salary Components", meta2 },
      { path: "manage-departments", component: ManageDepartment, name: "Manage Department", meta2 },
      { path: "manage-units", component: ManageUnit, name: "Manage Department Units", meta2 },
      { path: "manage-positions", component: ManagePosition, name: "Manage Positions", meta2 },

      { path: "employees-dashboard", component: ManageEmployeesDashboard, name: "Employees Dashboard", meta2 },
      { path: "manage-employees", component: ManageEmployees, name: "Manage Employees", meta2 },
      { path: "create-employee", component: CreateEmployee, name: "Create Employee", meta2 },
      { path: "employees/:id", component: EmployeeDetail, name: "Employee Details", meta },
      { path: "manage-employees-invites", component: ManageEmployeeInvites, name: "Manage Employees Invites", meta2 },

      { path: "workflow-setup", component: SetupWorkflow, name: "Manage Workflow Setup", meta2 },
      { path: "workflow-approvals", component: ManageApprovals, name: "Manage Workflow Approvals", meta2 },

      // HR — Attendance & Leave
      { path: "hr/attendance", component: HrAttendance, name: "HR Attendance", meta2 },
      { path: "hr/shifts", component: HrShifts, name: "HR Shifts", meta2 },
      { path: "hr/rota", component: HrRota, name: "HR Rota", meta2 },
      { path: "hr/my-dashboard",  component: MyDashboard, name: "My Dashboard",  meta2 },
      { path: "hr/my-attendance", component: MyAttendance, name: "My Attendance", meta2 },
      { path: "hr/my-shifts",    component: MyShifts,    name: "My Shifts",     meta2 },
      { path: "hr/my-payslips",  component: MyPayslips,  name: "My Payslips",   meta2 },
      { path: "hr/my-profile",   component: MyProfile,   name: "My Profile",    meta2 },
      { path: "hr/my-loans",   component: MyLoans,   name: "My Loans",   meta2 },
      { path: "hr/my-assets",  component: MyAssets,  name: "My Assets",  meta2 },
      { path: "hr/my-leaves", component: MyLeaves,  name: "My Leaves",  meta2 },
      { path: "hr/my-notifications",  component: MyNotifications,  name: "My Notifications",  meta2 },
      { path: "hr/my-announcements", component: MyAnnouncements, name: "My Announcements", meta2 },
      { path: "hr/my-documents",    component: MyDocuments,    name: "My Documents",    meta2 },
      { path: "hr/my-interviews",  component: MyInterviews,  name: "My Interviews",   meta2 },
      { path: "hr/loans",   component: HrLoans,     name: "HR Loans",     meta2 },
      { path: "assets",     component: HrAssets,    name: "Assets",       meta2 },
      { path: "hr/documents", component: HrDocuments, name: "HR Documents", meta2 },
      { path: "hr/recruitment", component: HrRecruitment, name: "HR Recruitment", meta2 },
      { path: "hr/recruitment/workforce-plan/create", component: WorkforcePlanForm, name: "WFP Create", meta2 },
      { path: "hr/recruitment/workforce-plan/:planId/edit", component: WorkforcePlanForm, name: "WFP Edit", meta2 },
      { path: "hr/recruitment/requisition/create", component: JobRequisitionForm, name: "Requisition Create", meta2 },
      { path: "hr/recruitment/requisition/:reqId/edit", component: JobRequisitionForm, name: "Requisition Edit", meta2 },
      { path: "hr/leave", component: HrLeave, name: "HR Leave", meta2 },
      { path: "hr/leave-balances", component: HrLeaveBalances, name: "HR Leave Balances", meta2 },
      { path: "hr/public-holidays", component: HrPublicHolidays, name: "HR Public Holidays", meta2 },
      { path: "hr/clients", component: HrClients, name: "HR Clients", meta2 },
      { path: "hr/announcements", component: HrAnnouncements, name: "HR Announcements", meta2 },
      { path: "hr/chat", component: HrChat, name: "HR Chat", meta2 },

      // PMS routes
      { path: "hr/performance/cycles", component: PmsCycles, name: "PMS Cycles", meta2 },
      { path: "hr/performance/cycles/:id", component: PmsCycleDetail, name: "PMS Cycle Detail", meta2 },
      { path: "hr/performance/goals", component: PmsGoals, name: "PMS Goals", meta2 },
      { path: "hr/performance/kpi-library", component: PmsKpiLibrary, name: "PMS KPI Library", meta2 },
      { path: "hr/performance/competencies", component: PmsCompetencies, name: "PMS Competencies", meta2 },
      { path: "hr/performance/reviews", component: PmsReviews, name: "PMS Reviews", meta2 },
      { path: "hr/performance/reviews/:id", component: PmsReviewForm, name: "PMS Review Form", meta2 },
      { path: "hr/performance/bonus-engine", component: PmsBonusEngine, name: "PMS Bonus Engine", meta2 },
      { path: "hr/performance/payroll-sync", component: PmsPayrollSync, name: "PMS Payroll Sync", meta2 },
      { path: "hr/performance/reports", component: PmsReports, name: "PMS Reports", meta2 },
      // Training
      { path: "hr/training/dashboard",     component: TrainingDashboard, name: "Training Dashboard",  meta2 },
      { path: "hr/training/courses",       component: TrainingCourses,   name: "Training Courses",    meta2 },
      { path: "hr/training/courses/new",   component: CourseForm,        name: "New Course",          meta2 },
      { path: "hr/training/courses/:id",   component: CourseForm,        name: "Edit Course",         meta2 },
      { path: "hr/training/my-training",    component: MyTraining,          name: "My Training",          meta2 },
      { path: "hr/training/assignments",              component: TrainingAssignments,  name: "Training Assignments",  meta2 },
      { path: "hr/training/enrolments",              component: TrainingEnrolments,   name: "Training Enrolments",   meta2 },
      { path: "hr/training/certificates",             component: TrainingCertificates, name: "Training Certificates", meta2 },
      { path: "hr/training/player/:enrolmentId",      component: TrainingPlayer,        name: "Training Player",       meta2 },

      { path: "hr/visitors/dashboard",    component: VisitorDashboard,   name: "Visitor Dashboard",    meta2 },
      { path: "hr/visitors/pre-register", component: VisitorPreRegister, name: "Pre-Register Visitor", meta2 },
      { path: "hr/visitors/upcoming",     component: VisitorUpcoming,    name: "Upcoming Visitors",    meta2 },
      { path: "hr/visitors/check-in",     component: VisitorCheckIn,     name: "Visitor Check-In",     meta2 },
      { path: "hr/visitors/active",       component: VisitorActive,      name: "Active Visitors",      meta2 },
      { path: "hr/visitors/history",      component: VisitorHistory,     name: "Visitor History",      meta2 },
      { path: "hr/visitors/directory",    component: VisitorDirectory,   name: "Visitor Directory",    meta2 },
      { path: "hr/visitors/types",        component: VisitorTypes,       name: "Visitor Types",         meta2 },
      { path: "hr/visitors/sites",        component: VisitorSites,       name: "Visitor Sites",         meta2 },
      { path: "hr/visitors/lockers",      component: VisitorLockers,     name: "Visitor Lockers",        meta2 },
      { path: "hr/visitors/watchlist",    component: VisitorWatchlist,   name: "Visitor Watchlist",     meta2 },
      { path: "hr/visitors/documents",    component: VisitorDocuments,   name: "Visitor Documents",     meta2 },
      { path: "hr/visitors/approvals",    component: VisitorApprovals,   name: "Visitor Approvals",     meta2 },
      { path: "hr/visitors/roll-call",    component: VisitorRollCall,    name: "Visitor Roll-Call",     meta2 },
      { path: "hr/visitors/evacuation",   component: VisitorEvacuation,  name: "Visitor Evacuation",    meta2 },
      { path: "hr/visitors/reports",      component: VisitorReports,     name: "Visitor Reports",       meta2 },
      { path: "hr/visitors/audit",        component: VisitorAuditTrail,  name: "Visitor Audit Trail",   meta2 },
      { path: "hr/visitors/dsr",          component: VisitorDSR,         name: "Visitor DSR",           meta2 },
      { path: "hr/visitors/group-visits", component: VisitorGroupVisits, name: "Visitor Group Visits",   meta2 },
      { path: "hr/visitors/settings",     component: VisitorSettings,    name: "Visitor Settings",     meta2 },
      { path: "developer/api-keys",  component: DeveloperApiKeys, name: "Developer API Keys",  meta2 },
      { path: "developer/webhooks", component: DeveloperWebhooks, name: "Developer Webhooks", meta2 },
      { path: "developer/docs",     component: DeveloperDocs,     name: "Developer Docs",     meta2 },

      {
        path: "wallet", component: BusinessWallet, name: "Business Wallet",
        beforeEnter(to, from, next) {
          const u = store.state.getLoggedInUser;
          const p = store.state.getCurrentUserPermission;
          if (u?.is_super === 1 || p?.wallet_module || p?.view_wallet) { next(); return; }
          if (p !== null) {
            const code = to.params.companyCode || localStorage.getItem('companyCode') || '';
            next(code ? `/${code}/hr/my-dashboard` : '/hr/my-dashboard');
          } else { next(); }
        },
      },

      { path: "hr/exits/pipeline",  component: ExitPipeline, name: "Exit Pipeline",  meta2 },
      { path: "hr/exits/create",    component: ExitCreate,   name: "Initiate Exit",  meta2 },
      { path: "hr/exits/settings",  component: ExitSettings, name: "Exit Settings",  meta2 },
      { path: "hr/exits",           component: ExitCases,    name: "Exit Cases",     meta2 },
      { path: "hr/exits/:id",       component: ExitShow,     name: "Exit Case",      meta2 },
      { path: "hr/my-exit",         component: MyExit,       name: "My Exit",        meta2 },

      { path: "support/tickets", component: SupportTickets, name: "Support Tickets", meta2 },

      { path: "procurement/dashboard", component: ProcurementDashboard, name: "Procurement Dashboard", meta2 },
      { path: "procurement/vendors", component: ProcurementVendors, name: "Vendor Directory", meta2 },
      { path: "procurement/vendor/:id", component: ProcurementVendorProfile, name: "Vendor Profile", meta2 },
      { path: "procurement/vendor-categories", component: VendorCategories, name: "Vendor Categories", meta2 },

      { path: "procurement/purchase-requisitions", component: PurchaseRequisitions, name: "Purchase Requisitions", meta2 },
      { path: "procurement/purchase-requisitions/create", component: PrForm, name: "Create PR", meta2 },
      { path: "procurement/purchase-requisitions/:id", component: PrDetail, name: "PR Detail", meta2 },
      { path: "procurement/purchase-requisitions/:id/edit", component: PrForm, name: "Edit PR", meta2 },
      { path: "procurement/purchase-requisitions/:id/print", component: PrintPR, name: "Print PR", meta2 },

      { path: "procurement/purchase-orders", component: PurchaseOrders, name: "Purchase Orders", meta2 },
      { path: "procurement/purchase-orders/create", component: PoForm, name: "Create PO", meta2 },
      { path: "procurement/purchase-orders/:id", component: PoDetail, name: "PO Detail", meta2 },
      { path: "procurement/purchase-orders/:id/edit", component: PoForm, name: "Edit PO", meta2 },
      { path: "procurement/purchase-orders/:id/print", component: PrintPO, name: "Print PO", meta2 },
      { path: "procurement/grns/:id/print", component: PrintGRN, name: "Print GRN", meta2 },
      { path: "procurement/sourcing-events", component: SourcingEvents, name: "Sourcing Events", meta2 },
      { path: "procurement/sourcing-events/create", component: SourcingEventForm, name: "Create Sourcing Event", meta2 },
      { path: "procurement/sourcing-events/:id", component: SourcingEventDetail, name: "Sourcing Event Detail", meta2 },
      { path: "procurement/sourcing-events/:id/edit", component: SourcingEventForm, name: "Edit Sourcing Event", meta2 },
      { path: "procurement/sourcing-events/:id/analysis", component: SourcingEventAnalysis, name: "Sourcing Event Analysis", meta2 },
      { path: "projects", component: PrjProjects, name: "Project Module", meta2 },
      { path: "projects/dashboard", component: PrjProjectDashboard, name: "Project Dashboard", meta2 },
      { path: "projects/:id", component: PrjProjectDetail, name: "Project Module Detail", meta2 },
      { path: "projects/budgets/:budgetId", component: PrjBudgetDetail, name: "Budget Detail", meta2 },
      { path: "timesheets", component: PrjTimesheet, name: "Timesheets", meta2 },

      { path: "crm/dashboard",     component: CrmDashboard,     name: "CRM Dashboard",     meta2 },
      { path: "crm/leads",         component: CrmLeads,         name: "CRM Leads",         meta2 },
      { path: "crm/contacts",      component: CrmContacts,      name: "CRM Contacts",      meta2 },
      { path: "crm/accounts",      component: CrmAccounts,      name: "CRM Accounts",      meta2 },
      { path: "crm/opportunities", component: CrmOpportunities, name: "CRM Opportunities", meta2 },
      { path: "crm/activities",    component: CrmActivities,    name: "CRM Activities",    meta2 },
      { path: "crm/segments",      component: CrmSegments,      name: "CRM Segments",      meta2 },
      { path: "crm/campaigns",     component: CrmCampaigns,     name: "CRM Campaigns",     meta2 },
      { path: "crm/journeys",      component: CrmJourneys,      name: "CRM Journeys",      meta2 },
      { path: "crm/cases",         component: CrmCases,         name: "CRM Cases",         meta2 },
      { path: "crm/loyalty",       component: CrmLoyalty,       name: "CRM Loyalty",       meta2 },
      { path: "crm/surveys",       component: CrmSurveys,       name: "CRM Surveys",       meta2 },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
